// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"_r-z","giftOrPromoSelector":"as-z","disabled":"bs-z","subTitle":"cs-z","selectShipAddressMessage":"ds-z","changePayment":"es-z"};